import React from "react";
import {
  Modal,
  Box,
  Typography,
  Paper,
  IconButton,
  Button,
  Switch,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { InputField } from "../../../pro/applicationForm/input";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
});

const ContentPlacementCategoryModal = ({
  open,
  onClose,
  onSave,
  initialData = {},
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        component={Paper}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "calc(100% - 24px)", sm: 420 },
          maxWidth: 420,
          maxHeight: { xs: "calc(100vh - 24px)", sm: "85vh" },
          overflow: "auto",
          bgcolor: "white",
          borderRadius: "12px",
          boxShadow: 24,
          padding: { xs: "16px", sm: "24px" },
        }}
      >
        <Formik
          validationSchema={validationSchema}
          initialValues={{
            name: initialData.name || "",
            rmn: initialData.rmn || false,
            autopilot_available: initialData.autopilot_available !== false,
          }}
          enableReinitialize
          onSubmit={(values) => {
            console.log("Category form submitted:", values);
            onSave(values);
          }}
        >
          {({ isValid, dirty, values, setFieldValue }) => (
            <Form className="flex flex-col gap-4">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography sx={{ fontSize: "24px", fontWeight: 900 }}>
                  {initialData?.id ? "Edit" : "Add"} Channel Category
                </Typography>
                <IconButton onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </Box>

              <InputField
                name="name"
                placeholder="Enter category name"
                label="Name"
                required
                type="text"
              />

              <FormControlLabel
                control={
                  <Switch
                    checked={values.rmn}
                    onChange={(e) => setFieldValue("rmn", e.target.checked)}
                    color="primary"
                  />
                }
                label="Parent"
              />

              <FormControlLabel
                control={
                  <Switch
                    checked={values.autopilot_available}
                    onChange={(e) => setFieldValue("autopilot_available", e.target.checked)}
                    color="primary"
                  />
                }
                label="Available for Autopilot"
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                  mt: 1,
                }}
              >
                <Button onClick={onClose} type="button">
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={!(isValid && dirty)}
                >
                  {initialData?.id ? "Save" : "Add"}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default ContentPlacementCategoryModal;
